export default __webpack_public_path__ + "resources/icons/n142-7a47.png";